export { default as SeoFragment } from './BlogSeo';